export default "__VITE_ASSET__fb353d0b__"